/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationTeamDetailsResource } from './';
import {
    OrganizationTeamDetailsResourceFromJSON,
    OrganizationTeamDetailsResourceFromJSONTyped,
    OrganizationTeamDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationTeamsResource
 */
export interface OrganizationTeamsResource {
    /**
     * 
     * @type {Array<OrganizationTeamDetailsResource>}
     * @memberof OrganizationTeamsResource
     */
    teams: Array<OrganizationTeamDetailsResource>;
}

/**
 * Check if a given object implements the OrganizationTeamsResource interface.
 */
export function instanceOfOrganizationTeamsResource(value: object): value is OrganizationTeamsResource {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    return true;
}

export function OrganizationTeamsResourceFromJSON(json: any): OrganizationTeamsResource {
    return OrganizationTeamsResourceFromJSONTyped(json, false);
}

export function OrganizationTeamsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationTeamsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(OrganizationTeamDetailsResourceFromJSON)),
    };
}

export function OrganizationTeamsResourceToJSON(value?: OrganizationTeamsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'teams': ((value['teams'] as Array<any>).map((v) => OrganizationTeamDetailsResourceToJSON(v))),
    };
}

